<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="centrosCusto.content"
      class="elevation-1 mt-5 pt-3 rounded-card"
      :loading="loading"
      :server-items-length="centrosCusto.total"
      @update:options="updateOptions"
      :footer-props="footerOptions"
      no-data-text="Nenhum centro de custo encontrado"
      loading-text="Carregando centros de custo..."
      :options="optionsList"
    >
      <template v-slot:item.descricao="{ item }">
        {{ item.descricao }}
      </template>
      <template v-slot:item.codigoInterno="{ item }">
        {{ item.codigoInterno | naoInformado }}
      </template>
      <template v-slot:item.options="{ item }" v-if="hasModuleGerencia">
        <div class="text-right">
          <v-btn icon
                @click="goToEditCentroCusto(item)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn icon
                @click="onClickDelete(item)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </div>
      </template>
    </v-data-table>
    <px-confirm-dialog ref="confirm"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    centrosCusto: Object,
    default: [],
    loading: Boolean,
    onChangeOptions: {
      type: Function,
      required: true,
    },
    optionsList: Object,
  },
  computed: {
    ...mapGetters('user', ['hasModuleGerencia']),
  },
  data() {
    return {
      footerOptions: {
        itemsPerPageOptions: [5, 10, 15, 20],
        itemsPerPageText: 'Linhas por página',
      },
      headers: [
        {
          text: 'Descrição',
          value: 'descricao',
        },
        {
          text: 'Código interno',
          value: 'codigoInterno',
        },
        {
          text: null,
          sortable: false,
          value: 'options',
        },
      ],
    };
  },
  methods: {
    updateOptions(options) {
      this.onChangeOptions(options);
    },
    remove(item) {
      this.$emit('remove', item);
    },
    goToEditCentroCusto(item) {
      this.$router.push({
        name: 'main.centros-custo.edicao',
        params: {
          id: item.id,
        },
      });
    },
    onClickDelete(item) {
      this.$refs.confirm.open('Você deseja remover este centro de custo?',
        'O centro de custo será removido e esta operação não pode ser desfeita.',
        { width: 450 })
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.remove(item);
        });
    },
  },
};
</script>
